



































































import { defineComponent, reactive, toRefs, computed, ref, onMounted } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";

export interface Data {
  school_id : number,
  student: any
  errors: any[],
  isShowPassword: boolean
  isInitialSetting: boolean
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      school_id : context.root.$store.state.currentUser.school_id,
      student: {
        password: "",
        password_new: "",
        password_confirmation: "",
      },
      errors: [],
      isShowPassword: false,
      isInitialSetting: context.root.$route.path.indexOf("inital_setting") != -1,
    });

    // 更新ボタン押下
    const updateClick = async () => {

      if(!validate() || !window.confirm("パスワードを更新します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      state.errors = [];
      await http.post(`/api/student/account/update_password`, {student: state.student}).then(response => {
        alert("パスワードの更新が完了しました。");
        context.root.$router.push(`/${state.school_id}/student_site/sheet_list`).catch(err => {});
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    // バリデーション
    const validate = () => {
      state.errors = [];

      var regex = new RegExp(/^(?=.*?[a-z])(?=.*?\d)[a-z\d]{8,100}$/i);
      if (!regex.test(state.student.password_new)) {
        state.errors.push("新しいパスワードのフォーマットを確認してください。");
      }

      if (state.student.password_new != state.student.password_confirmation) {
        state.errors.push("新しいパスワード欄と再入力欄の入力内容が異なります。");
      }

      return state.errors.length == 0;
    }

    const password_show = async () => {
      if (state.isShowPassword) {
        (document.getElementById('password_check') as any).type = "password";
        (document.getElementById('password_new_check') as any).type = "password";
        (document.getElementById('password_confirmation_check') as any).type = "password";
        state.isShowPassword = false;
      } else {
        (document.getElementById('password_check') as any).type = "text";
        (document.getElementById('password_new_check') as any).type = "text";
        (document.getElementById('password_confirmation_check') as any).type = "text";
        state.isShowPassword = true;
      }
    }

    const to = (page: string) => {
      context.root.$router.push(page).catch(err => {});
    }

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {
      
      var student = context.root.$store.state.currentUser.student;
      if (student != null && student.status == 1) {
        alert(`${context.root.$store.state.currentUser.student.name}さん、ありがとうございます。パスワードを登録してください`);
      }
    })

    return {
      ...toRefs(state),
      updateClick,
      password_show,
      to,
    }
  }
})
